import { stat } from './hooks/useHiidoPV';

export const convertHttps = (str: string) => {
  if (typeof str != 'undefined') {
    var r = str.replace(/http:/g, '');
    var reg = /^\/\/s[45]\.yy\.com/;
    if (reg.test(r)) {
      r = r.replace(reg, '//s1.yy.com');
    }
    return r;
  } else {
    return str;
  }
};

export enum HTTPService {
  Ok = 0
}

export enum UserRole {
  Unknown = 0,
  NormalGuild = 1,
  StarGuild = 2,
  GoldGuild = 3,
  NormalUser = 4,
  NormalAnchor = 5,
  StarAnchor = 6,
  GoldAnchor = 7
}

export const isGuild = (role: UserRole) =>
  [UserRole.NormalGuild, UserRole.StarGuild, UserRole.GoldGuild].includes(role);

export const isAnchor = (role: UserRole) =>
  [UserRole.NormalAnchor, UserRole.StarAnchor, UserRole.GoldAnchor].includes(
    role
  );

export enum AsyncState {
  Pending = 'pending',
  Resolved = 'resolved',
  Rejected = 'rejected'
}

/**
 * Usage:
 *  <img
 *    src={dynamicImportImages(`./relative-path-to-images-dir-${<some-variable>}.<extension>`)}
 *    alt="blah"
 *  />
 *
 * Takeaway:
 * https://github.com/survivejs/webpack-book/issues/80#issuecomment-216068406
 *
 */
// @ts-ignore
export const dynamicImportImages = require['context']('./images', true);

export function shortZhNum(number: string) {
  const num = parseFloat(number);

  if (!num) {
    return 0;
  }
  if (num < 100000) {
    return num;
  }
  if (num < 100000000) {
    return `${Math.floor((num / 10000) * 10) / 10}万`;
  }
  return `${Math.floor((num / 100000000) * 10) / 10}亿`;
}

/**
 * 千分符
 */
export const tsSep = (val?: string | number, decimal?: number) => {
  if (!val) return '0';

  let parts;
  if (decimal && decimal > 0) {
    val = (+val).toFixed(decimal);
  }
  parts = val.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const hiddoClick = (actType: string) => {
  stat.emit({
    eventid: 20042757,
    act_type: actType
  });
};

export const hiddoClickHOF = (actType: string) => (e: any) => {
  stat.emit({
    eventid: 20042757,
    act_type: actType
  });
};
